// extracted by mini-css-extract-plugin
export default {"pageContent":"PageContent_pageContent__Em7fk","pageContentNested":"PageContent_pageContentNested__kWBST"};